var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    {
      staticClass: "scroll-y",
      class: { "no-padding": _vm.quotes.length !== 0 },
      attrs: { name: "quotes" }
    },
    [
      _c("div", [
        _vm.quotes.length && !_vm.isSupplier
          ? _c(
              "div",
              {
                directives: [{ name: "is-user", rawName: "v-is-user" }],
                staticClass:
                  "row sticky-top bg-white q-px-md q-py-sm border-bottom customer-card__toolbar"
              },
              [
                _c("q-btn", {
                  attrs: { flat: "", icon: "add", label: _vm.$tc("quote", 1) },
                  on: { click: _vm.handleCreateQuote }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "text-select" },
          [
            _vm.quotes.length
              ? _c("quote-table", {
                  staticClass: "no-shadow",
                  attrs: {
                    quotes: _vm.quotes,
                    mapFunctionOverride: _vm.mapFunction,
                    columnsOverride: _vm.columns
                  }
                })
              : [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row justify-center items-center col-grow q-pt-lg"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("assets/emptystates/invoices_empty.svg"),
                              height: "100px"
                            }
                          }),
                          _c("h6", { staticClass: "q-my-md text-faded" }, [
                            _vm._v(_vm._s(_vm.$t("quotes_empty")))
                          ]),
                          !_vm.isSupplier
                            ? _c(
                                "q-btn",
                                {
                                  directives: [
                                    { name: "is-user", rawName: "v-is-user" }
                                  ],
                                  staticClass: "q-mt-lg",
                                  attrs: { color: "primary", outline: "" },
                                  on: { click: _vm.handleCreateQuote }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("create_quote")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }